export default {
    companySetting: 'Company Setting',
    profile: 'Profile',
    branch: 'Branch',
    userManagement: 'User Management',
    department: 'Department',
    companyHoliday: 'Company Holiday',
    leaveQuota: 'Leave Quota',
    blacklist: 'Blacklist'
}
